'use client';

import type { ClassValue } from 'clsx';

import { Carousel, CarouselContent, CarouselDots, CarouselItem } from '@vs-shop/ui/carousel';
import { Container } from '@vs-shop/ui/container';
import { clsxm } from '@vs-shop/utils';

import HomepageBannerCarouselItem from '../../../server/page/homepage/HomepageBannerCarouselItem';

import type { HomepageBanner } from '../../../../effect/schema/openapi/backend';

type Props = {
  banners: readonly HomepageBanner[];
  className?: ClassValue;
};

export default function HomepageBannerCarousel({ banners, className }: Props) {
  return (
    <Container
      classNameWrapper="bg-background-intense"
      classNameInner={clsxm('px-0 lap:px-0', className)}
    >
      <Carousel opts={{ loop: true }} data-slot="homepage-banner-carousel">
        <CarouselContent className="-ml-0">
          {banners.map((banner) => {
            return (
              <CarouselItem key={banner.id} className="pl-0" data-slot="homepage-banner-slide">
                <HomepageBannerCarouselItem banner={banner} />
              </CarouselItem>
            );
          })}
        </CarouselContent>
        <CarouselDots
          variant="bar"
          classNameDot="w-8 tab:w-12"
          className={clsxm(
            'absolute inset-x-0 flex items-center justify-center gap-x-1 tab:gap-x-2',
            'bottom-14 tab:bottom-20 lap:bottom-[104px]'
          )}
        >
          {({ index }) => <span className="sr-only">{banners[index]?.title}</span>}
        </CarouselDots>
      </Carousel>
    </Container>
  );
}
